import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { AllVideosFilter } from "./all-videos-filter";
import { VideoListGrid } from "./video-list-grid";

type ContainerProps = {
  $enableFilter?: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: grid;
  grid:
    "all-videos-filter" min-content
    "all-videos-list" min-content
    / 100%;
  row-gap: 20px;

  max-inline-size: 1272px;
  margin-block-end: 40px;

  ${theme.breakpoints.up("tablet")} {
    grid:
      "all-videos-filter all-videos-list" min-content
      / minmax(0, 160px) minmax(0, 1fr);
    row-gap: 32px;
    border-block-start: 1px solid rgba(0, 0, 0);

    padding-block-start: 32px;
  }

  ${props =>
    !props.$enableFilter &&
    css`
      display: flex;
      justify-content: center;
    `}
`;

export const StyledAllVideosFilter = styled(AllVideosFilter)`
  grid-area: all-videos-filter;
`;

export const StyledVideoListGrid = styled(VideoListGrid)`
  grid-area: all-videos-list;
`;
